import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { ENV_API2_HOST, ENV_WS2_HOST, repaired_hostname, protocol, isProdOrTestnet } from '@bfe/by-env';
/* eslint-disable */

var BYBIT_COOKIE_DOMAIN = process.env.BYBIT_COOKIE_DOMAIN;
var BYBIT_API2_HOST = process.env.BYBIT_API2_HOST;
var BYBIT_WS2_HOST = process.env.BYBIT_WS2_HOST;
/* eslint-disable */

var isSSL = protocol === 'https:';
var wsProtocol = isSSL ? 'wss:' : 'ws:'; // default config to dev-3

var isDev = true;
var env = 'public-test-1';
var domain = 'bybit';
var domainType = 'com';
var domainTypeLocale = '';

if (process.env.NODE_ENV === 'production') {
  isDev = false;
  var hostSplits = repaired_hostname ? repaired_hostname.split('.') : [];

  if (hostSplits.length === 3) {
    // www.bybit.com
    // testnet.bybit.com
    // m.bybit.com
    // m-testnet.bybit.com
    var _hostSplits = _slicedToArray(hostSplits, 3);

    env = _hostSplits[0];
    domain = _hostSplits[1];
    domainType = _hostSplits[2];
  }

  if (hostSplits.length === 4) {
    if (isProdOrTestnet) {
      // www.bybit.com.hk
      var _hostSplits2 = _slicedToArray(hostSplits, 4);

      env = _hostSplits2[0];
      domain = _hostSplits2[1];
      domainType = _hostSplits2[2];
      domainTypeLocale = _hostSplits2[3];
      domainType = "".concat(domainType, ".").concat(domainTypeLocale);
    } else {
      // www.cht-test-1.bybit.com
      var _hostSplits3 = _slicedToArray(hostSplits, 4);

      env = _hostSplits3[1];
      domain = _hostSplits3[2];
      domainType = _hostSplits3[3];
    }
  } // www.cht-test-1.bybit.com.hk


  if (hostSplits.length === 5) {
    var _hostSplits4 = _slicedToArray(hostSplits, 5);

    env = _hostSplits4[1];
    domain = _hostSplits4[2];
    domainType = _hostSplits4[3];
    domainTypeLocale = _hostSplits4[4];
    domainType = "".concat(domainType, ".").concat(domainTypeLocale);
  }
}

var isDevNeedSSL = isDev && (env === 'dev-3' || env === 'test-3');
/**
 * env can be 1 of [
 * 'www',
 * 'm',
 * 'testnet', 'm-testnet'
 * 'test-1', 'test-2', 'test-3,
 * 'dev-1', 'dev-2', 'dev-3'
 * ] etc.
 */

var envReg = /^(www|m)$/;
var isProdOrTestnetReg = /^(www|m|testnet|m-testnet)$/;
var isTestnet = env === 'testnet' || env === 'm-testnet';
var cdnStaticProd = 's1.bycsi.com';
export var cdnStatic = isTestnet ? 't1.bycsi.com' : cdnStaticProd;
export var isProd = isProdOrTestnetReg.test(env);
export var DYNAMIC_ENV = env;
export var currentDomain = "".concat(domain, ".").concat(domainType);
var api2ServicePrefix = "api2.".concat(!envReg.test(env) ? "".concat(env, ".") : '');
var ws2ServicePrefix = "ws2.".concat(!envReg.test(env) ? "".concat(env, ".") : '');
var chatPrefix = "chat.".concat(!envReg.test(env) ? "".concat(env, ".") : '');
var affiliatesPrefix = 'affiliates.';

if (isTestnet) {
  api2ServicePrefix = 'api2-testnet.';
  chatPrefix = 'chat-testnet.';
  ws2ServicePrefix = 'ws2-testnet.';
  affiliatesPrefix = 'affiliates-testnet.';
}

var tmsPath = '';

if (!isProd) {
  tmsPath = 'https://tms.ffe390afd658c19dcbf707e0597b846d.de';
  affiliatesPrefix = "affiliates.".concat(env, ".");
}

export var AFFILIATES_HOST = "https://".concat(affiliatesPrefix).concat(domain, ".").concat(domainType);
export var api2Prefix = api2ServicePrefix;
export var ws2Prefix = ws2ServicePrefix;
export var DOMAIN = domain;
export var DOMAIN_TYPE = domainType;
export var TOKEN_COOKIE_KEY = BYBIT_COOKIE_DOMAIN || "b_t_c_k".concat(envReg.test(env) ? '' : "_".concat(env));
export var CDN_STATIC_PROD = "https://".concat(cdnStaticProd);
export var CDN_STATIC = "https://".concat(cdnStatic);
export var CHAT_URL = "".concat(protocol, "//").concat(chatPrefix).concat(domain, ".").concat(domainType, "/chat/by-chat-widget.js");
export var apiProtocol = isDevNeedSSL ? 'https:' : protocol;
export var ws2Protocol = isDevNeedSSL ? 'wss:' : wsProtocol;
export var API2_HOST = '/x-api';
export var WS2_HOST = BYBIT_WS2_HOST || ENV_WS2_HOST || "".concat(ws2Protocol, "//").concat(ws2Prefix).concat(domain, ".").concat(domainType); // 只针对期权的特有的测试环境 infra-gateway.public-test-1.bybit.com

export var OPTION_TEST_GATEWAY_HOST = "".concat(protocol, "//infra-gateway.").concat(env, ".").concat(domain, ".").concat(domainType);
export var OPTION_TEST_WS_HOST = "".concat(ws2Protocol, "//www.").concat(env, ".").concat(domain, ".").concat(domainType);
export var OPTION_ALL_ENV = envReg.test(env) ? '' : "_".concat(env);
export var TMS_HOST = process.env.BYBIT_TMS_HOST || tmsPath; // export const ZENDESK_HOST = 'https://bybit.zendesk.com';

export var ZENDESK_HOST = "https://help.".concat(domain, ".com");
export var BLOG_HOST = "https://blog.".concat(domain, ".com"); // zendesk urls

export var zBaseLink = "".concat(ZENDESK_HOST, "/hc");
export var helpLang = {
  'en-US': 'en-us',
  'zh-CN': 'zh-cn',
  'zh-TW': 'zh-tw',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'ru-RU': 'en-us',
  'vi-VN': 'en-us'
};
export var helpCenterHost = isProd ? '' : 'https://www.bybit.com'; // 获取当前id对应的帮助中心链接

export var getHelpLink = function getHelpLink(lang, path) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/").concat(path);
}; // 帮助中心首页
// 帮助中心当前地址没有测试环境, 因此判断是测试环境就访问 www.bybit.com
// 参考路由: https://www.bybit.com/en-US/help-center/HelpCenterKnowledge/bybitHC_HomePage?language=en_US

export var helpCenterHomePage = function helpCenterHomePage(lang) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/HelpCenterKnowledge/bybitHC_HomePage");
}; //  标记价格

export var zMarkPrice = function zMarkPrice(lang) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001117");
}; //  交割标记价格

export var zMarkPriceFuture = function zMarkPriceFuture(lang) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001080");
}; // 反向强平价格

export var zLiquidation = function zLiquidation(lang) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001100");
}; // 正向强平价格

export var zLinearLiquidation = function zLinearLiquidation(lang) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001067");
}; // 反向风险限额

export var zRiskLimit = function zRiskLimit(lang) {
  var currentLang = lang || "en-US";
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/article/Risk-Limit-Perpetual-and-Futures");
}; // 正向风险限额

export var zRiskLimitForward = function zRiskLimitForward(lang) {
  var currentLang = lang || "en-US";
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001164");
}; // 交易费用, 反向永续/正向永续

export var TFEEURL = function TFEEURL(lang) {
  var currentLang = lang || "en-US";
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001584");
}; // 交易费用, 反向交割

export var FITFEEURL = function FITFEEURL(lang) {
  var currentLang = lang || "en-US";
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/article/Perpetual-Futures-Contract-Fees-Explained");
}; // 资金费率计算

export var FFEEURL = function FFEEURL(lang) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001123");
}; // 指数价格

export var INDEXPRICEURL = function INDEXPRICEURL(lang) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001055");
}; // 交割 指数价格

export var FUTUREINDEXPRICEURL = function FUTUREINDEXPRICEURL(lang) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001076");
}; // 正向 仓位保证金

export var zLinearPositionMargin = function zLinearPositionMargin(lang) {
  var currentLang = lang || 'en-US';
  return "".concat(helpCenterHost, "/").concat(currentLang, "/help-center/apex/bybitHC_Article?id=000001391");
};
export var exportUrl = isProd ? 'https://public.bybit.com' : process.env.BYBIT_EXPORT_URL;
export * from './replaceContentDomain';